module.exports = __webpack_public_path__ + "static/media/app-icon.ee71998c.png";